import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const ThemedBox = styled(Box)(({ theme }) => ({
    color: theme.palette.contrastDefault.main,
    backgroundColor: theme.palette.background.main,
    borderRadius: '10px'
}));

export { ThemedBox }; 